// extracted by mini-css-extract-plugin
export default {"previewContainer":"styles-module__previewContainer__src-labstep-web-components-ProtocolStep-Item-_sd0Tl"};